import Http from './http'
import _ from 'lodash'

export const get = (activityId) => Http.get(`/sections/${activityId}`)

export const fields = (sectionId) => Http.get(`/section/${sectionId}/fields`)

export const convertFieldsToCascader = (fields) => {
  let cascader = {children: []}
  _.each(fields, (field) => {
    cascader.children.push({
      value: field.spq_codigo,
      label: `${field.spq_descricao} (${field.spq_codigo})`
    })
  })
  return cascader
}

export const convertSectionToCascader = (section) => {
  return {
    value: section.sec_codigo,
    label: `${section.sec_descricao} (${section.sec_codigo})`
  }
}

export const mergeSectionAndFieldsCascader = (sectionCascader, fieldsCascader) => {
  return {...sectionCascader, ...fieldsCascader}
}

export default {
  get,
  fields,
  convertFieldsToCascader,
  convertSectionToCascader,
  mergeSectionAndFieldsCascader
}